import type { ComponentType } from "react";
import styled from "@emotion/styled";

type IconWeight = "thin" | "light" | "regular" | "bold" | "fill" | "duotone";

export type PhosphorIconComponent = ComponentType<{
  size?: number | string;
  weight?: IconWeight;
  className?: string;
  "aria-hidden"?: boolean | "true" | "false";
}>;

export type IconProps = {
  icon: PhosphorIconComponent;
  size?: "xs" | "sm" | "md" | "lg" | number;
  weight?: IconWeight;
  className?: string;
  decorative?: boolean;
};

const sizeMap = {
  xs: 13,
  sm: 16,
  md: 20,
  lg: 24
};

/* Exact compiled output of the pre-migration Tailwind utilities. The styled
 * root is rendered `as` the provided Phosphor icon component (a non-string
 * tag, so Emotion forwards every prop — size/weight/aria-hidden — through). */

const IconRoot = styled("svg", {
  label: "AgenticIcon-root"
})<{ as?: PhosphorIconComponent; size?: number | string; weight?: IconWeight }>({
  display: "inline-block",
  flexShrink: 0,
  verticalAlign: "middle"
});

export function Icon({ icon: IconComponent, size = "md", weight = "regular", className, decorative = true }: IconProps) {
  const resolvedSize = typeof size === "number" ? size : sizeMap[size];
  return <IconRoot as={IconComponent} aria-hidden={decorative} className={className} size={resolvedSize} weight={weight} />;
}
